import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 20,
        marginTop: 30,
        // boxShadow: '0 0 0 1px rgb(63 63 68 / 5%), 0 9px 22px 0 rgb(51 46 49 / 15%)',
    },
    wrapper: {
        height: '100%',
        // justifyContent: 'space-between',
    },
    header: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',

        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(1),
        },
    },
    description: {
        marginBottom: theme.spacing(1),
    },
    reportTitle: {
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center',
        },
    },
    reportDate: {
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center',
        },
    },
    filter: {
        display: 'flex',
        flexWrap: 'wrap',

        '& > :not(:first-child)': {
            marginLeft: 8,
        },

        [theme.breakpoints.up('sm')]: {
            flexBasis: 'auto',
            marginTop: 0,
        },
        '& .MuiOutlinedInput-root': {
            height: '35px',
        },
        '& .MuiToggleButtonGroup-root': {},
        '& .MuiToggleButtonGroup-grouped': {
            height: 35,
            padding: 0,
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: '#FFFFFF',
            outline: 0,
        },
        '& .MuiOutlinedInput-input': {
            padding: '10.5px 14px',
            width: '70px',
        },
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'flex-end',
        alignContent: 'center',
        flexWrap: 'wrap',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start',
        },
    },
    title: {
        marginBottom: theme.spacing(1),
        flexGrow: 2,
        maxWidth: '100%',

        '& > :first-child': {
            paddingRight: theme.spacing(1.5),
        },
    },
    titleText: {
        fontSize: 16,
        color: 'black',
        overflow: 'hidden',
    },
    dateText: {
        fontSize: 16,
        color: '#b9b9b9',
    },
    toggleButton: {
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
        maxHeight: '38px',
    },
    toggleIcon: {
        padding: 11,
        paddingTop: 16,
    },
    rangeSelect: {
        '& .MuiOutlinedInput-input': {
            width: '100px',
            padding: '10.5px 14px',
        },
    },
    reloadLink: {
        textTransform: 'lowercase',
        fontStyle: 'italic',
        fontSize: 18,
        margin: '0px 5px',
        cursor: 'pointer',
    },
}));
